/** Backend aggregate dashboard. Statistical values must be supplied by the API. */
const ASSET_BASE = "/mobility-report";

const escapeScriptJson = (value) =>
  JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028|\u2029/g, "");

const statsMarkup = `
<div class="app">
  <!-- Mobility Report screens: required by app.js, never shown here -->
  <div class="screen" id="screen1"><div id="patientList"></div></div>
  <div class="screen" id="screen2"><div id="detailBody"></div></div>
  <div class="screen" id="screen3"><div id="choiceContext"></div><div id="activityCard"><select id="activitySelect"></select></div></div>
  <div class="screen" id="screen4"><div id="reportTitle"></div><div id="reportBody"></div></div>
  <div class="screen" id="screen5"><div id="trendTitle"></div><div id="trendSubtitle"></div><div id="trendBody"></div></div>
  <div class="screen" id="screen6"><div id="exerBody"></div></div>

  <!-- POPULATION — home (Pic 1 layout) -->
  <div class="screen" id="screenPopulation">
    <div class="sub-header">
      <button class="back-btn" onclick="exitPopulation()" aria-label="Back">‹</button>
      <div class="sub-header-titles">
        <div class="sub-header-title" id="popUserName"></div>
        <div class="sub-header-subtitle" id="popPageName"></div>
      </div>
    </div>
    <div class="report-body" id="popBody"></div>
  </div>

  <div class="modal-backdrop" id="modalBackdrop"><div class="modal-card"><button class="modal-x" onclick="closeModal()">×</button><div class="modal-title" id="modalTitle"></div><div class="modal-subtitle" id="modalSubtitle"></div><div class="modal-body" id="modalBody"></div></div></div>
  <div class="toast" id="toast"></div>
</div>
`;

/**
 * The first argument is retained for call-site compatibility and is ignored.
 * context.aggregate is mandatory; localized labels are supplied by the host.
 */
export const buildStatsSrcDoc = (_population, context) => {
  if (!context?.aggregate) throw new Error("Population aggregate is required");
  return `
<!doctype html>
<html lang="${context.locale}">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
  <link rel="stylesheet" href="${ASSET_BASE}/mobility.css" />
  <link rel="stylesheet" href="${ASSET_BASE}/typography.css" />
  <link rel="stylesheet" href="${ASSET_BASE}/stats.css" />
  <style>
    @media (min-width: 768px) {
      html, body { width: 100%; min-height: 100vh; padding: 0; background: #f1f5f9; display: block; }
      .app { width: 100%; max-width: none; height: auto; min-height: 100vh; margin: 0; border-radius: 0; box-shadow: none; }
    }
  </style>
</head>
<body>
${statsMarkup}
  <script>
    var STATS_HOST_ORIGIN = ${escapeScriptJson(context.hostOrigin || "")};
    function exitPopulation() { window.parent.postMessage({ type: "seniorlife:stats-back" }, STATS_HOST_ORIGIN); }
    function exitReport() { exitPopulation(); }
  </script>
  <script src="${ASSET_BASE}/resident_support_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/care_support_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/stats.js"></script>
  <script>
    try {
      popInit(${escapeScriptJson({ ...context, aggregateRequired: true })});
      window.parent.postMessage({ type: "seniorlife:stats-ready" }, STATS_HOST_ORIGIN);
    } catch (error) {
      window.parent.postMessage({ type: "seniorlife:stats-error" }, STATS_HOST_ORIGIN);
    }
  </script>
</body>
</html>`;
};
